(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-rounded"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener( 'DOMContentLoaded', function() {
      var elem = document.querySelector('.featuredcollectionrounded');
      var flkty = new Flickity( elem, {
        freeScroll: true,
        contain: true,
        pageDots: false
      });
  } );

  } catch(e) { console.error(e); }
})();
})();
